import { useState } from 'react'
import { AppIcon } from '../../services/apps/AppIcon'

/**
 * The app's own crumb (RFC 0332), and the way to what the agent is told about
 * it (RFC 0334 3g): a click drops a menu whose row opens the app's skill
 * document in the editor. A menu, not a sheet, so the skill is edited where
 * every other document is. A plain tile for an app with no skill, so it never
 * offers something that is not there.
 */
export function AppTile({
  appId,
  name,
  onOpenSkill,
}: {
  appId: string
  name: string
  onOpenSkill?: () => void
}) {
  const [open, setOpen] = useState(false)
  if (!onOpenSkill)
    return (
      <span title={name} className="flex shrink-0 items-center">
        <AppIcon appId={appId} size={13} />
        <span className="sr-only">{name}</span>
      </span>
    )
  return (
    <span className="relative flex shrink-0 items-center">
      <button
        type="button"
        title={name}
        aria-label={`${name} menu`}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center rounded hover:bg-muted"
      >
        <AppIcon appId={appId} size={13} />
      </button>
      {open && (
        <>
          <button
            type="button"
            aria-label="Close menu"
            className="fixed inset-0 z-10 cursor-default"
            onClick={() => setOpen(false)}
          />
          <div className="absolute top-full left-0 z-20 mt-1 w-40 overflow-hidden rounded-md border border-border bg-background py-1 shadow-lg">
            <div className="px-3 py-1 text-[11px] text-muted-foreground">
              {name}
            </div>
            <button
              type="button"
              onClick={() => {
                setOpen(false)
                onOpenSkill()
              }}
              className="block w-full px-3 py-1.5 text-left text-xs hover:bg-muted"
            >
              Open skill
            </button>
          </div>
        </>
      )}
    </span>
  )
}
